<template>
    <div>
        <div class="favorite-coins mx-10">
            <!-- Header cố định -->
            <div class="main-header search-box">
                <div class="select-form">
                    <select v-model="periods" class="select-custom font-bold bg-white">
                        <option value="">Select time</option>
                        <option value="1m">1m</option>
                        <option value="3m">3m</option>
                        <option value="5m">5m</option>
                        <option value="15m">15m</option>
                        <option value="30m">30m</option>
                        <option value="1h">1h</option>
                        <option value="2h">2h</option>
                        <option value="4h">4h</option>
                        <option value="6h">6h</option>
                        <option value="12h">12h</option>
                        <option value="1d">1d</option>
                    </select>
                </div>
                <div class="select-form" v-if="selectedMetrics.includes('inflow30d')">
                    <select v-model="inflowDays" class="select-custom font-bold bg-white">
                        <option :value="15">15d</option>
                        <option :value="30">30d</option>
                        <option :value="45">45d</option>
                        <option :value="60">60d</option>
                    </select>
                </div>

                <!-- Coin Input with Dropdown -->
                <div class="coin-input-wrapper">
                    <div v-if="selectedCoin" class="selected-coin-badge-inline">
                        <span class="badge-coin-name">{{ selectedCoin.coinName }}</span>
                        <button @click="clearSelectedCoin" class="badge-close-btn" title="Clear">×</button>
                    </div>
                    <input
                        v-else
                        type="text"
                        v-model="coinSearchQuery"
                        @focus="openCoinDropdown"
                        @blur="closeCoinDropdown"
                        @input="openCoinDropdown"
                        placeholder="Select coin"
                        class="header-search"
                    />
                    <div class="coin-dropdown" v-if="showCoinDropdown">
                        <div class="coins-list">
                            <div
                                v-for="coin in filteredCoinsList"
                                :key="coin.id"
                                class="coin-item"
                                @click="selectCoin(coin)"
                            >
                                <div class="coin-name">{{ coin.coinName }}</div>
                                <div class="coin-exchanges-inline">
                                    <span v-if="coin.isBinance === 'Y'" class="exchange-badge">Binance</span>
                                    <span v-if="coin.isMexc === 'Y'" class="exchange-badge">Mexc</span>
                                    <span v-if="coin.isBybit === 'Y'" class="exchange-badge">Bybit</span>
                                </div>
                            </div>
                            <div v-if="filteredCoinsList.length === 0" class="coin-item disabled">
                                No coins found
                            </div>
                        </div>
                    </div>
                </div>

                <button @click="handleRefresh"
                    class="refresh-btn">
                    Refresh
                </button>
            </div>


        </div>
    </div>
</template>
<script>
import { API_URL } from "../../config";
import '@/assets/css/allcoins.css'

export default {
    name: "AllCoins",
    props: {
        selectedMetrics: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            periods: "",
            coins: [],
            selectedCoin: null,
            selectedCoinName: "",
            showCoinDropdown: false,
            showSelectedCoinDetails: false,
            coinSearchQuery: "",
            loading: false,
            error: null,
            inflowDays: 30
        };
    },
    created() {
        this.fetchCoins();
    },
    methods: {
        async fetchCoins() {
            try {
                this.loading = true;
                const response = await fetch(`${API_URL}/all/get-coins`);

                if (!response.ok) {
                    throw new Error('Failed to fetch coins');
                }

                const data = await response.json();

                if (Array.isArray(data)) {
                    this.coins = data;
                } else {
                    throw new Error('Invalid data format');
                }
            } catch (error) {
                console.error("Error fetching coins:", error);
                this.error = error.message;
            } finally {
                this.loading = false;
            }
        },

        openCoinDropdown() {
            this.showCoinDropdown = true;
        },

        closeCoinDropdown() {
            setTimeout(() => {
                this.showCoinDropdown = false;
            }, 100);
        },

        filterCoins() {
            // Không cần filter vì input là readonly
        },

        selectCoin(coin) {
            this.selectedCoin = coin;
            this.selectedCoinName = coin.coinName;
            this.showCoinDropdown = false;
            this.coinSearchQuery = "";
            // Nếu chưa chọn period, dùng mặc định 5m
            const period = this.periods || "5m";
            // Update periods để giao diện hiển thị đúng
            if (!this.periods) {
                this.periods = "5m";
            }
            this.$emit('period-selected', { coin: coin, period: period });
        },

        clearSelectedCoin() {
            this.selectedCoin = null;
            this.selectedCoinName = "";
            this.coinSearchQuery = "";
            this.showCoinDropdown = true;
        },

        getSelectedCoinExchanges() {
            if (!this.selectedCoin) return [];

            const exchanges = [];
            if (this.selectedCoin.isBinance === 'Y') exchanges.push('Binance');
            if (this.selectedCoin.isMexc === 'Y') exchanges.push('Mexc');
            if (this.selectedCoin.isBybit === 'Y') exchanges.push('Bybit');

            return exchanges;
        },

        handleRefresh() {
            this.fetchCoins();
            this.$emit('refresh-clicked', { coin: this.selectedCoin, period: this.periods });
        }
    },
    computed: {
        filteredCoinsList() {
            if (!this.coinSearchQuery.trim()) {
                return this.coins;
            }

            const query = this.coinSearchQuery.toLowerCase();
            return this.coins.filter(coin =>
                coin.coinName.toLowerCase().includes(query)
            );
        }
    },
    watch: {
        periods(newVal) {
            this.$emit('period-selected', { coin: this.selectedCoin, period: newVal });
        },
        inflowDays(newVal) {
            this.$emit('inflow-days-changed', newVal);
        }
    }
};
</script>